import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

import { Input } from "rbx";

function NumberInput({
  name,
  label,
  value,
  disabled,
  onChange,
  readOnly,
  ...props
}) {
  const [innerValue, setInnerValue] = useState(parseInt(value));

  useEffect(() => {
    setInnerValue(parseInt(value));
  }, [value]);

  return (
    <Input
      autocomplete="new"
      {...props}
      className="input"
      disabled={disabled}
      id={label}
      name={name}
      readOnly={readOnly}
      type="number"
      value={innerValue}
      onChange={onChange}
    />
  );
}
NumberInput.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.number,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  readOnly: PropTypes.bool
};

NumberInput.defaultProps = {
  value: 0,
  readOnly: false
};
export default NumberInput;
